<template>
  <v-container fluid>
    <v-breadcrumbs large class="pa-0" :items="breadcrumbsItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-tabs v-model="tab">
      <v-tab key="home">Hlavné údaje</v-tab>
      <v-tab key="map">Mapa</v-tab>
      <v-tab key="mb_dilat" v-if="bod.MbDilatsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MB DILAT - {{ bod.MbDilatsCount }}</span>
          </template>
          <span>{{ getDescription("mb_dilat") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="dilat" v-if="bod.DilatsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">DILAT - {{ bod.DilatsCount }}</span>
          </template>
          <span>{{ getDescription("dilat") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="mb_hpv" v-if="bod.MbHpvsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MB HPV - {{ bod.MbHpvsCount }}</span>
          </template>
          <span>{{ getDescription("mb_hpv") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="hpv" v-if="bod.HpvsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">HPV - {{ bod.HpvsCount }}</span>
          </template>
          <span>{{ getDescription("hpv") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="hpvq" v-if="bod.HpvqsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">HPVQ - {{ bod.HpvqsCount }}</span>
          </template>
          <span>{{ getDescription("hpvq") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="mb_ink" v-if="bod.MbInksCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MB INK - {{ bod.MbInksCount }}</span>
          </template>
          <span>{{ getDescription("mb_ink") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="inkp" v-if="bod.InkpsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">INKP - {{ bod.InkpsCount }}</span>
          </template>
          <span>{{ getDescription("inkp") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="inks" v-if="bod.InkssCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">INKS - {{ bod.InkssCount }}</span>
          </template>
          <span>{{ getDescription("inks") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="geo" v-if="bod.GeosCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">GEO - {{ bod.GeosCount }}</span>
          </template>
          <span>{{ getDescription("geo") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="prna" v-if="bod.PRNAsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">PRNA - {{ bod.PRNAsCount }}</span>
          </template>
          <span>{{ getDescription("prna") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="mb_stab" v-if="bod.MbStabsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MB STABSKAL - {{ bod.MbStabsCount }}</span>
          </template>
          <span>{{ getDescription("mb_stab") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="stab" v-if="bod.StabsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">STABSKAL - {{ bod.StabsCount }}</span>
          </template>
          <span>{{ getDescription("stab") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="mb_mikro" v-if="bod.MbMikrosCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MB MIKRONIV - {{ bod.MbMikrosCount }}</span>
          </template>
          <span>{{ getDescription("mb_mikro") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="mikro" v-if="bod.MikrosCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MIKRONIV - {{ bod.MikrosCount }}</span>
          </template>
          <span>{{ getDescription("mikro") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="mb_pt" v-if="bod.MbPTsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MB PT - {{ bod.MbPTsCount }}</span>
          </template>
          <span>{{ getDescription("mb_pt") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="pt" v-if="bod.PTsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">PT - {{ bod.PTsCount }}</span>
          </template>
          <span>{{ getDescription("pt") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="mb_potrub" v-if="bod.MbPotrubsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">MB POTRUB - {{ bod.MbPotrubsCount }}</span>
          </template>
          <span>{{ getDescription("mb_potrub") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="potrub" v-if="bod.PotrubsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">POTRUB - {{ bod.PotrubsCount }}</span>
          </template>
          <span>{{ getDescription("potrub") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="peep" v-if="bod.PEEPsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">PEEP - {{ bod.PEEPsCount }}</span>
          </template>
          <span>{{ getDescription("peep") }}</span>
        </v-tooltip>
      </v-tab>
      <v-tab key="pees" v-if="bod.PEESsCount > 0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">PEES - {{ bod.PEESsCount }}</span>
          </template>
          <span>{{ getDescription("pees") }}</span>
        </v-tooltip>
      </v-tab>

      <v-tab-item key="home">
        <v-container class="mt-2 elevation-3" fluid>
          <v-row dense>
            <v-col md="2" class="font-weight-black">ID:</v-col>
            <v-col>{{ bod.ID }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">IDMB:</v-col>
            <v-col>{{ bod.IDMB }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">IDMBP:</v-col>
            <v-col>{{ bod.IDMBP }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">ZNMB:</v-col>
            <v-col>{{ bod.ZNMB }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">X,Y,Z JTSK:</v-col>
            <v-col>
              <i>[{{ bod.X }}, {{ bod.Y }}, {{ bod.Z }}]</i>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">WGS 84:</v-col>
            <v-col>
              <i>{{ bod.Lat }}, {{ bod.Lng }}</i>
              <br />
              <a
                :href="'http://boulter.com/gps/?c=' + bod.Lat + '+' + bod.Lng"
                target="_blank"
                >Zobraz na mape</a
              >
            </v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Obdobie:</v-col>
            <v-col>{{ getObdobieString }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Poznámka:</v-col>
            <v-col>{{ bod.Poznamka }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black"
              >Zobrazovať na verejnej časti:</v-col
            >
            <v-col>{{ bod.Zobrazovat ? "Áno" : "Nie" }}</v-col>
          </v-row>
          <v-btn @click="editBod()">Editovať</v-btn>
          <v-menu top :offset-x="true">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">Pridať meranie</v-btn>
            </template>

            <v-list>
              <v-list-item dense @click="addMer('mb_hpv')">
                <v-list-item-title>Hladiny podz.vody - body</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('hpv')">
                <v-list-item-title>Hladiny podz.vody</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('hpvq')">
                <v-list-item-title>Hladiny podz.vody - Q</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('geo')">
                <v-list-item-title>Geodetické</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('prna')">
                <v-list-item-title>Povrchové reziduálne</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('mb_dilat')">
                <v-list-item-title>Dilatometrické - body</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('dilat')">
                <v-list-item-title>Dilatometrické</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('peep')">
                <v-list-item-title>PEE - primárne</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('pees')">
                <v-list-item-title>PEE - sekundárne</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('mb_potrub')">
                <v-list-item-title
                  >Prieč.rozm.zmeny potrubia - body</v-list-item-title
                >
              </v-list-item>
              <v-list-item dense @click="addMer('potrub')">
                <v-list-item-title>Prieč.rozm.zmeny potrubia</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('mb_mikro')">
                <v-list-item-title>
                  Mikromorfologické merania skalnej steny - body
                </v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('mikro')">
                <v-list-item-title
                  >Mikromorfologické merania skalnej steny</v-list-item-title
                >
              </v-list-item>
              <v-list-item dense @click="addMer('mb_stab')">
                <v-list-item-title>
                  Dilatometrické merania skalných blokov - body
                </v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="addMer('stab')">
                <v-list-item-title
                  >Dilatometrické merania skalných blokov</v-list-item-title
                >
              </v-list-item>
              <v-list-item dense @click="addMer('mb_ink')">
                <v-list-item-title
                  >Inklinometrické merania - body</v-list-item-title
                >
              </v-list-item>
              <v-list-item dense @click="addMer('inkp')">
                <v-list-item-title
                  >Inklinometrické merania prenosné</v-list-item-title
                >
              </v-list-item>
              <v-list-item dense @click="addMer('inks')">
                <v-list-item-title
                  >Inklinometrické merania stacionárne</v-list-item-title
                >
              </v-list-item>
              <v-list-item dense @click="addMer('mb_pt')">
                <v-list-item-title
                  >Merania pórových tlakov - body</v-list-item-title
                >
              </v-list-item>
              <v-list-item dense @click="addMer('pt')">
                <v-list-item-title>Merania pórových tlakov</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-container>
      </v-tab-item>
      <v-tab-item key="map">
        <v-container class="mt-2 elevation-3" fluid>
          <l-map
            :zoom="zoom"
            :center="center"
            style="height: 600px; width: 100%; z-index: 0"
            ref="map"
            @ready="setMapView"
          >
            <l-control-scale
              position="topright"
              :imperial="false"
              :metric="true"
            ></l-control-scale>
            <l-control position="bottomright">
              <v-img :src="require('../assets/nautical.svg')"></v-img>
            </l-control>
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />
            <l-marker
              v-if="bod.Lat != 0 && bod.Lng != 0"
              :lat-lng="[bod.Lat, bod.Lng]"
            ></l-marker>
          </l-map>
        </v-container>
      </v-tab-item>
      <v-tab-item key="mb_dilat" v-if="bod.MbDilatsCount > 0">
        <meranie-table
          typ="mb_dilat"
          :itemsCount="bod.MbDilatsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="dilat" v-if="bod.DilatsCount > 0">
        <meranie-table
          typ="dilat"
          :itemsCount="bod.DilatsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="mb_hpv" v-if="bod.MbHpvsCount > 0">
        <meranie-table
          typ="mb_hpv"
          :itemsCount="bod.MbHpvsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="hpv" v-if="bod.HpvsCount > 0">
        <!--meranie-graf typ="hpv" :items="hpvTableItems" /-->
        <meranie-table
          typ="hpv"
          :itemsCount="bod.HpvsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
          @loaded="hpvTableItems = $event"
        />
      </v-tab-item>
      <v-tab-item key="hpvq" v-if="bod.HpvqsCount > 0">
        <!--meranie-graf typ="hpv" :items="hpvqTableItems" /-->
        <meranie-table
          typ="hpvq"
          :itemsCount="bod.HpvqsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
          @loaded="hpvqTableItems = $event"
        />
      </v-tab-item>
      <v-tab-item key="mb_ink" v-if="bod.MbInksCount > 0">
        <meranie-table
          typ="mb_ink"
          :itemsCount="bod.MbInksCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="inkp" v-if="bod.InkpsCount > 0">
        <meranie-table
          typ="inkp"
          :itemsCount="bod.InkpsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="inks" v-if="bod.InkssCount > 0">
        <meranie-table
          typ="inks"
          :itemsCount="bod.InkssCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="geo" v-if="bod.GeosCount > 0">
        <v-container class="mt-2 elevation-3" fluid>
          <geo-pohybova-aktivita
            :body="[
              {
                ID: bod.ID,
                Lat: bod.Lat,
                Lng: bod.Lng,
                MerGeos: geoTableItems,
              },
            ]"
          ></geo-pohybova-aktivita>
        </v-container>
        <meranie-table
          typ="geo"
          :itemsCount="bod.GeosCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
          @loaded="geoTableItems = $event"
        />
      </v-tab-item>
      <v-tab-item key="prna" v-if="bod.PRNAsCount > 0">
        <meranie-table
          typ="prna"
          :itemsCount="bod.PRNAsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="mb_stab" v-if="bod.MbStabsCount > 0">
        <meranie-table
          typ="mb_stab"
          :itemsCount="bod.MbStabsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="stab" v-if="bod.StabsCount > 0">
        <meranie-table
          typ="stab"
          :itemsCount="bod.StabsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="mb_mikro" v-if="bod.MbMikrosCount > 0">
        <meranie-table
          typ="mb_mikro"
          :itemsCount="bod.MbMikrosCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="mikro" v-if="bod.MikrosCount > 0">
        <meranie-table
          typ="mikro"
          :itemsCount="bod.MikrosCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="mb_pt" v-if="bod.MbPTsCount > 0">
        <meranie-table
          typ="mb_pt"
          :itemsCount="bod.MbPTsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="pt" v-if="bod.PTsCount > 0">
        <meranie-table
          typ="pt"
          :itemsCount="bod.PTsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="mb_potrub" v-if="bod.MbPotrubsCount > 0">
        <meranie-table
          typ="mb_potrub"
          :itemsCount="bod.MbPotrubsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="potrub" v-if="bod.PotrubsCount > 0">
        <meranie-table
          typ="potrub"
          :itemsCount="bod.PotrubsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="peep" v-if="bod.PEEPsCount > 0">
        <meranie-table
          typ="peep"
          :itemsCount="bod.PEEPsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
      <v-tab-item key="pees" v-if="bod.PEESsCount > 0">
        <meranie-table
          typ="pees"
          :itemsCount="bod.PEESsCount"
          :bodId="bod.ID"
          @delete="readBod(bod.ID)"
        />
      </v-tab-item>
    </v-tabs>

    <bod-detail ref="dialogBod" @change="readBod(bod.ID)"></bod-detail>
    <meranie-dialog
      :typ="typNovehoMerania"
      :editable="true"
      ref="dialogMeranie"
      @change="readBod(bod.ID)"
      @delete="readBod(bod.ID)"
    />
  </v-container>
</template>

<script>
import BodDetail from "../components/BodDetail.vue"
import * as Enums from "../plugins/enums.js"
import MeranieTable from "../components/MeranieTable.vue"
import MeranieDialog from "../components/MeranieDialog.vue"
import {
  LMap,
  LMarker,
  LControl,
  LControlLayers,
  LControlScale,
  LTileLayer
} from "vue2-leaflet"
import * as Miscella from "../plugins/miscella.js"
import GeoPohybovaAktivita from "../components/GeoPohybovaAktivita.vue"
//import MeranieGraf from "../components/MeranieGraf.vue"

export default {
  components: {
    LMap,
    LTileLayer,
    LControl,
    LControlLayers,
    LControlScale,
    BodDetail,
    MeranieTable,
    MeranieDialog,
    LMarker,
    GeoPohybovaAktivita
    //MeranieGraf
  },

  data: () => ({
    tab: 0,
    bod: {
      DilatsCount: 0,
      HpvsCount: 0,
      HpvqsCount: 0,
      InkpsCount: 0,
      InkssCount: 0,
      GeosCount: 0,
      PRNAsCount: 0,
      StabsCount: 0,
      MikrosCount: 0,
      PTsCount: 0,
      PotrubsCount: 0,
      PEEPsCount: 0,
      PEESsCount: 0,
      MbPotrubsCount: 0,
      MbPTsCount: 0,
      MbHpvsCount: 0,
      MbDilatsCount: 0,
      MbStabsCount: 0,
      MbMikrosCount: 0,
      MbInksCount: 0,
      Lokalita: {},
      Lat: 0,
      Lng: 0
    },
    typNovehoMerania: "",
    mapOptions: {
      zoomSnap: 0.5
    },

    zoom: 8,
    center: [48.6, 19.7],
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
    geoTableItems: [],
    hpvTableItems: [],
    hpvqTableItems: [],
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ]
  }),

  computed: {
    breadcrumbsItems: function() {
      let ret = null
      if (Miscella.isSet(this.bod)) {
        ret = [
          {
            to: { name: "lokalita", params: { id: this.bod.Lokalita.ID } },
            text: "Lokalita " + this.bod.Lokalita.Name
          },
          { text: "Bod " + this.bod.ID + " - " + this.bod.ZNMB }
        ]
      }
      return ret
    },
    getObdobieString: function() {
      let ret = this.bod.DatumOdString
      if (ret !== "") {
        ret += " - "
      }
      ret += this.bod.DatumDoString
      return ret
    }
  },

  methods: {
    editBod: function() {
      this.$refs.dialogBod.show(this.bod)
    },

    readBod: async function(id) {
      console.log("BOD, readBod")
      try {
        let response = await this.$axios.get("/r/bod/" + id)
        if (response.status === 200) {
          this.bod = this.transformItem(response.data)
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    transformItem: function(item) {
      item.DatumOd = Miscella.zeroDatum(item.DatumOd)
      item.DatumDo = Miscella.zeroDatum(item.DatumDo)
      item.DatumOdString = Miscella.formatDatum(item.DatumOd)
      item.DatumDoString = Miscella.formatDatum(item.DatumDo)
      return item
    },
    setMapView: function() {
      this.$nextTick(() => {
        if (this.bod.Lat != 0 && this.bod.Lng != 0) {
          this.$refs.map.mapObject.setView([this.bod.Lat, this.bod.Lng], 12)
        }
      })
    },
    addMer: function(typMer) {
      this.typNovehoMerania = typMer
      this.$nextTick(
        function() {
          this.$refs.dialogMeranie.show({ ID: 0, BodID: this.bod.ID })
        }.bind(this)
      )
    },
    getDescription: function(mer) {
      return Enums.getDescription(mer)
    }
  },

  mounted: async function() {
    console.log("bod mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    await this.readBod(this.$route.params.id)
  }
}
</script>

//TODO https://www.nayuki.io/res/convex-hull-algorithm/convex-hull.js
